import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React from 'react'
import { createMVPModal } from '../Modal'
import { LoadingModalView, LoadingModalViewProps } from './LoadingModalView'

class LoadingModal
{
	Show(props: LoadingModalViewProps) : (() => void)
	{
		let modalCallback = () => {
			/* */
		}

		NiceModal.show(createMVPModal('loading-modal', () =>
		{
			const modal = useModal()
			modalCallback = () => {
				modal.hide()
			}

			return <LoadingModalView  {...props}/>
		}, true))
		return () => { modalCallback() }
	}
}

const modal = new LoadingModal()
export default modal
